export default __webpack_public_path__ + "static/media/fb.f51db061.svg";